import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Breakpoint,
} from "@mui/material";

export interface CustomDialogProps {
  mostrar: boolean;
  onClose: () => void;
  titulo?: string | React.ReactNode;
  header?: React.ReactNode;
  contenido: React.ReactNode;
  acciones?: React.ReactNode;
  fullWidth?: boolean;
  tamanioMaximo?: Breakpoint;
  pantallaCompleta?: boolean;
}

const CustomDialog = ({
  mostrar,
  onClose,
  titulo,
  contenido,
  acciones,
  tamanioMaximo,
  fullWidth,
  pantallaCompleta,
  header,
}: CustomDialogProps) => {
  return (
    <Dialog
      open={mostrar}
      onClose={onClose}
      maxWidth={tamanioMaximo}
      fullWidth={fullWidth}
      fullScreen={pantallaCompleta}
      TransitionProps={{ unmountOnExit: true }}
    >
      {header}
      <DialogTitle>{titulo}</DialogTitle>
      <DialogContent>{contenido}</DialogContent>
      <DialogActions>{acciones}</DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
